import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { toast } from "react-toastify";
import { IoMdAdd } from "react-icons/io";
import Modal from "@/features/shared/components/Modal/Modal";
import ContractTypeFilters from "@/features/contractType/components/ContractTypeFilters";
import ContractTypeTable from "@/features/contractType/components/ContractTypeTable";
import ContractTypeForm from "@/features/contractType/components/ContractTypeForm";
import useContractTypeManagement from "@/features/contractType/hooks/useContractTypeManagement";
import ParameterPagination from "@/features/parameter/components/ParameterPagination";
const defaultFilters = {
    search: "",
};
const ContractTypesPage = () => {
    const [filters, setFilters] = useState({ ...defaultFilters });
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedContractType, setSelectedContractType] = useState(null);
    const { contractTypes, meta, loading, error, handleCreateContractType, handleUpdateContractType, handleDeleteContractType, refetchContractTypes, } = useContractTypeManagement(currentPage, filters, rowsPerPage);
    const handleFilterChange = (filterName, value) => {
        setFilters((previous) => ({ ...previous, [filterName]: value }));
        setCurrentPage(1);
    };
    const handleDelete = async (contractType) => {
        const confirmation = window.confirm(`Supprimer le type de contrat « ${contractType.label} » ?`);
        if (!confirmation) {
            return;
        }
        try {
            await handleDeleteContractType(contractType.code);
            toast.success("Type de contrat supprimé avec succès");
            refetchContractTypes();
        }
        catch (apiError) {
            const message = apiError instanceof Error ? apiError.message : "Suppression impossible.";
            toast.error(message);
        }
    };
    const handleSubmit = async (payload) => {
        try {
            if (selectedContractType) {
                await handleUpdateContractType({
                    code: selectedContractType.code,
                    contractType: {
                        label: payload.label,
                        ...(payload.code !== selectedContractType.code ? { new_code: payload.code } : {}),
                    },
                });
                toast.success("Type de contrat mis à jour avec succès");
            }
            else {
                await handleCreateContractType(payload);
                toast.success("Type de contrat créé avec succès");
            }
            setSelectedContractType(null);
            setIsModalOpen(false);
            refetchContractTypes();
        }
        catch (apiError) {
            const message = apiError instanceof Error ? apiError.message : "Enregistrement impossible.";
            toast.error(message);
            throw apiError;
        }
    };
    return (_jsxs("div", { className: "space-y-6", children: [_jsx("header", { className: "flex flex-col gap-3 md:flex-row md:items-center md:justify-between", children: _jsxs("div", { children: [_jsxs("div", { className: "mb-2 flex gap-4", children: [_jsx("h4", { className: "text-xl font-bold", children: "Types de contrat" }), _jsx("button", { onClick: () => {
                                        setSelectedContractType(null);
                                        setIsModalOpen(true);
                                    }, title: "Ajouter un type de contrat", className: "rounded", children: _jsx(IoMdAdd, { className: "bg-blue-500 text-white hover:bg-blue-600" }) })] }), _jsx("p", { className: "text-sm text-gray-600", children: "G\u00E9rer les types de contrats disponibles (CDI, CDD, stage, etc.)." })] }) }), error && (_jsxs("div", { className: "rounded border border-yellow-200 bg-yellow-50 p-4 text-sm text-yellow-800", children: [_jsx("div", { className: "font-medium", children: "Une erreur est survenue" }), _jsx("p", { children: error }), _jsx("button", { type: "button", onClick: () => refetchContractTypes(), className: "mt-3 rounded border border-yellow-400 px-3 py-1 text-yellow-700 hover:bg-yellow-100", children: "R\u00E9essayer" })] })), _jsx(ContractTypeFilters, { filters: filters, onFilterChange: handleFilterChange }), _jsxs("section", { className: "rounded border border-gray-200 bg-white shadow-sm", children: [_jsxs("header", { className: "flex items-center justify-between border-b border-gray-200 px-4 py-3", children: [_jsx("div", { children: _jsx("h2", { className: "text-lg font-medium text-gray-900", children: "Liste des types de contrat" }) }), _jsxs("span", { className: "text-sm text-gray-500", children: [contractTypes.length, " type(s)"] })] }), loading ? (_jsx("div", { className: "p-6 text-sm text-gray-500", children: "Chargement des types de contrat\u2026" })) : (_jsx(ContractTypeTable, { contractTypes: contractTypes, onEdit: (contractType) => {
                            setSelectedContractType(contractType);
                            setIsModalOpen(true);
                        }, onDelete: handleDelete }))] }), meta && meta.totalPages && meta.totalPages > 1 && (_jsx(ParameterPagination, { currentPage: meta.page ?? 1, totalPages: meta.totalPages, limit: meta.limit ?? rowsPerPage, onPageChange: (page) => setCurrentPage(page), onLimitChange: (value) => {
                    setRowsPerPage(value);
                    setCurrentPage(1);
                } })), isModalOpen && (_jsx(Modal, { onClose: () => setIsModalOpen(false), children: _jsx(ContractTypeForm, { initialData: selectedContractType ?? undefined, onSubmit: handleSubmit, onCancel: () => {
                        setIsModalOpen(false);
                        setSelectedContractType(null);
                    } }) }))] }));
};
export default ContractTypesPage;
